/** Backend field names, as the mapping config and `scimMappedFields` spell them. */
export const IDP_FIELDS = {
  jobTitle: 'job_title',
  department: 'department',
  manager: 'manager',
  employmentType: 'employment_type',
  startDate: 'start_date',
  costCentre: 'cost_centre',
  site: 'site',
  region: 'region',
  country: 'country',
  employeeId: 'employee_id',
} as const;

/** Every name `scimMappedFields` can carry, so a typo is a compile error rather than a field that never locks. */
export type IdpField = (typeof IDP_FIELDS)[keyof typeof IDP_FIELDS] | `custom_field_${number}`;

export const JOB_CARD_FIELDS: IdpField[] = [
  IDP_FIELDS.jobTitle,
  IDP_FIELDS.department,
  IDP_FIELDS.manager,
  IDP_FIELDS.employmentType,
  IDP_FIELDS.startDate,
  IDP_FIELDS.costCentre,
  IDP_FIELDS.site,
  IDP_FIELDS.region,
  IDP_FIELDS.country,
];

export const customFieldName = (slot: number): IdpField => `custom_field_${slot}`;
